import Nav_module_default from "./Nav.module.js";
import classNames from "classnames";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Nav/NavBar.tsx
/**
* A navigation bar component
*/
var NavBar = ({ children, className, role, "aria-label": ariaLabel, ...rest }) => {
	const classes = classNames(className, Nav_module_default["nav-bar"]);
	/**
	* We sometimes want to use this NavBar for tabs.
	* This is done by passing `role=tablist` to this component.
	* By default, this component is used as a navigation bar.
	*
	* Depending on this role, a different set of accessibility
	* attributes need to be applied to the nav/ul element.
	*/
	const a11yAttributesForNav = role !== "tablist" ? {
		role: "navigation",
		"aria-label": ariaLabel
	} : { role: "presentation" };
	/**
	* When used as tabs, the tablist role must be applied to ul.
	* When used as navigation, no special accessibility attribute
	* is needed for the ul element.
	*/
	const a11yAttributesForUl = role === "tablist" ? {
		role: "tablist",
		"aria-label": ariaLabel
	} : {};
	return /* @__PURE__ */ jsx("nav", {
		...a11yAttributesForNav,
		...rest,
		className: classes,
		children: /* @__PURE__ */ jsx("ul", {
			...a11yAttributesForUl,
			className: Nav_module_default["nav-bar-items"],
			children
		})
	});
};
//#endregion
export { NavBar };

//# sourceMappingURL=NavBar.js.map